import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { westBendConfig } from "./data";

export default function WestBendPage() {
  return <CityPageTemplate config={westBendConfig} />;
}